let dataLayerInited = false;

export class DataLayerTracker {
    constructor(data) {
        this.dataLayer = this.init(data);
        console.log(data);
    }

    /**
     * Инициализируем начальный dataLayer
     * @param data
     * @returns {*|Array}
     */
    init(data = {}) {
        window.dataLayer = window.dataLayer || [];
        if (dataLayerInited) {
            return window.dataLayer;
        }

        const initialLayer = {
            isLogged: data.user.authorized,
        };

        // if (initialLayer.isLogged) {
        //     initialLayer.user = {
        //         birthdate: data.user.born_at ? data.user.born_at.short : 'unknown',
        //         gender: data.user.gender ? data.user.gender : 'unknownn',
        //         regDate: data.user.registered_at.short
        //     };
        // }

        switch (data.route) {
            case 'index':
                initialLayer.pagetype = 'main';
                break;
            case 'catalog_products':
                initialLayer.pagetype = 'catalog';
                break;
            case 'catalog_product':
                initialLayer.pagetype = 'product';
                break;
            case 'order':
                initialLayer.pagetype = 'order';
                break;
            case 'order.thankyoupage':
                initialLayer.pagetype = 'confirmation';
                break;
            case '404':
                initialLayer.pagetype = '404';
                break;
            default:
                initialLayer.pagetype = 'other';
                break;
        }

        window.dataLayer.push(initialLayer);

        dataLayerInited = true;
        return window.dataLayer;
    }

    push(layer) {
        this.dataLayer.push(layer);
    }

    categoryPageView(products) {

        //https://yandex.ru/support/metrica/ecommerce/data.html
        this.push({ecommerce: null});
        this.push({
            'event': 'impressions',
            "ecommerce": {
                "currencyCode": "RUB",
                "impressions": products
                //products
                /*"impressions": [
                    {
                        "id": "P15432",
                        "name" : "Футболка",
                        "price": 477.60,
                        "brand": "Яндекс / Яndex",
                        "category": "Одежда/Мужская одежда/Футболки",
                        "variant" : "Красный цвет",
                        "list": "Search",
                        "position": 1
                    },
                    {
                        "id": "P15435",
                        "name" : "Футболка",
                        "price": 500.60,
                        "brand": "Яндекс / Яndex",
                        "category": "Одежда/Мужская одежда/Футболки",
                        "variant" : "Синий цвет",
                        "list": "Search",
                        "position": 2
                    }
                ]*/
            }
        });

        // #18588 Событие используется для Criteo счетчика. Туда нужно передавать только три первых товара из списка
        /*const productIds = products.map((product) => {
            return product.id;
        });

        this.push({
            'event': 'viewList',
            'item': productIds.slice(0, 3)
        });*/
    }

    productPageView(product) {
        this.push({ecommerce: null});
        this.push({
            event: 'detail',
            ecommerce: {
                detail: {
                    products: {
                        id: product.id,
                        name: product.name,
                        price: parseFloat(product.price),
                        brand: product.vendor,
                        category: product.category
                    }
                }
            }
        });
    }

    basketItemAdd(product) {
        this.push({ecommerce: null});
        this.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'RUB',
                'add': {
                    'products': collectBasketItems([product])
                }
            }
        });
    }

    basketItemRemove(product) {
        this.push({ecommerce: null});
        this.push({
            event: 'remove',
            ecommerce: {
                'currencyCode': 'RUB',
                'remove': {
                    'products': collectBasketItems([product])
                }
            }
        });
    }




    // basketPageView(basket) {
    //     this.push({
    //         'ecommerce': {
    //             'checkout': {
    //                 'actionField': {'step': 1},
    //                 'products': collectBasketItems(basket)
    //             }
    //         }
    //     });
    //
    //     this.push({
    //         'event' : 'ecommerceCheckout',
    //         'ecommerce': {
    //             'checkout': {
    //                 'actionField': {'step': 1},
    //                 'products': collectBasketItems(basket)
    //             }
    //         }
    //     });
    // }

    cartPageView(basket) {
        this.push({ecommerce: null});
        this.push({
            'event': 'checkout_step_1',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': 1,
                        'option': 'Cart'
                    },
                    'products': collectBasketItems(basket)
                }
            }
        });
    }

    orderPageView(basket) {
        this.push({ecommerce: null});
        this.push({
            'event': 'checkout_step_2',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': 2,
                        'option': 'Checkout'
                    },
                    'products': collectBasketItems(basket)
                }
            }
        });
    }

    // orderPageReload(basket) {
    //     this.push({'ecommerce': {
    //         'checkout': {
    //             'actionField': {'step': 3},
    //             'products': collectBasketItems(basket)
    //         }
    //     }});
    //
    //     this.push({
    //         'event' : 'ecommerceCheckout',
    //         'ecommerce': {
    //             'checkout': {
    //                 'actionField': {'step': 3},
    //                 'products': collectBasketItems(basket)
    //             }
    //         }
    //     });
    // }

    /*orderPageLoyalityCardValidtion(card) {
        this.push({
            'event': 'checkoutOption',
            'ecommerce': {
                'checkout_option': {
                    'actionField': {'step': 2, 'option': 'подтвердил пин код бонусной карты'},
                    'card1' : card.number,
                    'card2' : card.pin
                }
            }
        })
    }*/

    orderThankyouPageView(order, basket) {
        this.push({ecommerce: null});
        this.push({
            'event': 'purchase',
            'ecommerce': {
                'currencyCode': 'RUB',
                'purchase': {
                    'actionField': {
                        id: order.id,
                        affiliation: window.location.host,
                        revenue: order.price,
                        tax: order.tax,
                        shipping: order.delivery_price,
                        coupon: order.coupon
                    },
                    'products': collectBasketItems(basket)
                }
            }
        });
    }


    catalogProductClick(product) {
        this.push({ecommerce: null});
        this.push({
            "event": "productClick",
            "ecommerce": {
                "currencyCode": "RUB",
                "click": {
                    "products": [
                        product
                    ]
                }
            }
        });


        //dataLayer.push({
        //     "ecommerce": {
        //         "currencyCode": "RUB",
        //         "click": {
        //             "products": [
        //                 {
        //                     "id": "39084",
        //                     "name": "Термостакан Яндекс",
        //                     "price": 1089.69,
        //                     "brand": "Яндекс / Яndex",
        //                     "category": "Товары для дома/Посуда/Термосы и термокружки",
        //                     "variant": "Красный цвет",
        //                     "list": "Search",
        //                     "position": 1
        //                 }
        //             ]
        //         }
        //     }
        // });
    }

}


let collectBasketItems = (basket) => {
    const items = [];
    basket.forEach((basketItem) => {
        items.push(formatBasketItem(basketItem));
    });
    return items;
};
let formatBasketItem = (product) => {
    if (!product) {
        return {};
    }

    return {
        id: product.id,
        name: product.name,
        price: product.price,
        category: product.category,
        quantity: product.quantity
        //variant: '',
        //brand: product.vendor,
    };
}


let formatBasketItemGa4 = (product) => {

    if (!product) {
        return {};
    }

    return {
        item_name: product.name,
        item_id: product.id,
        price: product.price,
        item_brand: product.vendor,
        item_category: product.category,
        quantity: product.quantity
    };
};
let collectBasketItemsGa4 = (basket) => {
    const items = [];
    basket.forEach((basketItem) => {
        items.push(formatBasketItemGa4(basketItem));
    });
    return items;
};



// WEBPACK FOOTER //
// ./modules/tracker/datalayer.js